module.exports = __webpack_public_path__ + "res/20-img_cards_bg.c1a167d412292a13832d61b3bf46844f.png";